export default "__VITE_ASSET__9f178ae9__"